// src/services/companyService.js
import { apiService } from './api';

export const companyService = {
  // Récupérer toutes les entreprises
  async getCompanies() {
    const response = await apiService.get('/companies/supadmin');
    return response.data;
  },

  // Créer une nouvelle entreprise
  async createCompany(companyData) {
    const response = await apiService.post('/companies/supadmin', companyData);
    return response;
  },

  // Récupérer une entreprise spécifique
  async getCompany(id) {
    const response = await apiService.get(`/companies/supadmin/${id}`);
    return response;
  },

  // Mettre à jour une entreprise
  async updateCompany(id, companyData) {
    const response = await apiService.put(`/companies/supadmin/${id}`, companyData);
    return response;
  },

  // Supprimer une entreprise
  async deleteCompany(id) {
    const response = await apiService.delete(`/companies/supadmin/${id}`);
    return response;
  },

  // Régénérer la clé API
  async regenerateApiKey(id) {
    const response = await apiService.post(`/companies/supadmin/${id}/regenerate-api-key`);
    return response;
  },

  async uploadLogo(id, formData) {
    const response = await apiService.post(
      `/companies/supadmin/${id}/logo`, 
      formData, 
      true // ← IMPORTANT: indique que c'est un FormData
    );
    return response;
  },
  
  // Supprimer un logo
  async deleteLogo(id) {
    const response = await apiService.delete(`/companies/supadmin/${id}/logo`);
    return response;
  },

};